export const formatNumber = (num: number): string => {
  return num.toLocaleString('en-US');
};

export const formatQuantity = (quantity: number): string => {
  if (quantity >= 1000000) {
    return `${(quantity / 1000000).toFixed(1)}M`;
  }
  if (quantity >= 1000) {
    return `${(quantity / 1000).toFixed(1)}K`;
  }
  return quantity.toString();
};

export const truncateItemName = (name: string): string => {
  const numberMatch = name.match(/^\d[\d,.]*/);
  if (numberMatch) {
    return numberMatch[0];
  }
  return name.split(' ')[0];
};
